import Select from 'react-select';
import ErrorText from '../ErrorText/ErrorText';
import { Props } from './interfaces';
import './SelectCust.scss';
import './SelectCust-media.scss';
import {content} from "../../services/content";

const SelectCust = ({ options, placeholder = '', value, setSelectValue, error }: Props) => {
  return (
    <div className="select-cust">
      <p className="select-cust__label" style={{ marginTop: '40px' }}>
        {content.formContacts.topic}
      </p>
      <Select
        options={options}
        placeholder={placeholder}
        isSearchable={false}
        className="select-input__item"
        classNamePrefix="select-input"
        onChange={(selectedOpt: any) => setSelectValue(selectedOpt)}
        value={value}
      />
      {error ? ErrorText(error) : null}
    </div>
  );
};

export default SelectCust;
